<template>
  <div v-if="!isApp" :class="headerClass">
    <div class="header" style="z-index: 2000">
        <div class="header-left">
          <app-menu v-if="menu" class="header-left-menu"/>
        </div>
        <p class="header-title" v-if="!isWechat">
          {{ title }}
        </p>
        <!-- <div class="" v-else-if="!isHidden">
          <search class="i-search"/>
        </div> -->
        <div class="header-right">
          <slot></slot>
          <div class="detail-icon detail-group" v-if="cart">
            <div class="carts-icon" @click="goCarts">
              <i></i>
              <div class="fix-num" v-if="cartNum > 0">
                <div class="cart-num">{{ cartNum }}</div>
                <div class="triangle-right"></div>
              </div>
            </div>
          </div>
        </div>
    </div>
    <div class="placeholder"></div>
  </div>

</template>

<script>
import { weixin, app } from '@beastshop/browser'
import AppMenu from '@/components/app-menu'
import Search from '@/components/search'
import events from '@/plugins/events'
import Vue from 'vue'
import { getCartNum } from './api.js'
Vue.use(events)
export default {
  components: {
    AppMenu,
    Search
  },
  name: 'header',
  props: {
    cart: {
      type: Boolean,
      default: false
    },
    menu: {
      type: Boolean,
      default: false
    },
    isHidden: { // hide navbar or not
      type: Boolean,
      default: true
    },
    title: {
      type: String,
      default: '加载中...'
    }
  },

  data () {
    return {
      isApp: app(),
      isWechat: weixin(),
      cartNum: 0
    }
  },

  created(){
    console.log(this._on, 'o')
    this._on('change-title', data=>{
      console.log(data,'tsr')
      this.title= data
    })
  },

  mounted () {
    // if (this.isWechat) {
    //   const searchWrap = document.querySelector('.detail-icon .search-wrap')

    //   if (searchWrap) {
    //     searchWrap.parentElement.style.display = 'none'
    //   }
    // }

    if (this.cart) {
      getCartNum()
      .then(data => {
        this.cartNum = data || 0
      })
    }
  },

  computed: {
    headerClass: function () {
      return (this.isWechat && this.isHidden)
          ? 'header-wechat'
          : 'header-wap'
    }
  },

  methods: {
    goCarts () {
      window.location.href = '/cart'
    }
  }
}
</script>

<style lang="stylus">
  @import '../../common/styl/global'
  .search-input
    input
      position relative
      top rem(-2)

  .detail-icon
    float left
    margin-left rem(15)
    .i-search
      position relative
      top rem(15)
    .carts-icon
      position relative
      top rem(15)
      i
        display block
        width rem(22)
        height rem(22)
        background url(./assets/icon-cart.png) 0 0 no-repeat
        background-size 100%
      .fix-num
        position absolute
        top rem(-22)
        right rem(-20)
        .cart-num
          min-width rem(12)
          min-height rem(16)
          background #000
          display inline-block
          border-radius rem(8)
          font-size rem(10)
          line-height rem(16)
          color #fff
          text-align center
          padding 0 rem(2)
        .triangle-right
          display inline-block
          width 0
          height 0
          border-top rem(5) solid transparent
          border-left rem(8) solid #000
          border-bottom rem(5) solid transparent
          position relative
          left rem(-8)
          top rem(2)
  .header-left
    position fixed
    z-index 100
    top rem(15)
    left rem(15)
  .header-left-menu
    width rem(22)
    height rem(22)
  .header-right
    position absolute
    top 0
  .header-wap
    .header
      position fixed
      top 0
      left 0
      width 100%
      height rem(48)
      text-align center
      line-height rem(48)
      z-index 1000
      color #2B2B2B
      font-size rem(17)
      border-bottom rem(1) solid #E1E1E1
      background #FFF
      .header-right
        right rem(15)
      .header-title
        padding 0 rem(60)
        overflow hidden
        text-overflow ellipsis
        white-space nowrap
    .placeholder
      height rem(48)
.header-wechat
  padding 0 rem(9)
  &.no-left
    .header-left
      display none
  .header
    position fixed
    top rem(25)
    left 0
    width 100%
    z-index 11
    color #2B2B2B
    font-size rem(17)
    .header-left
      top rem(25)
    .header-right
      right rem(9)
    .header-title
      display none
</style>



// WEBPACK FOOTER //
// index.vue?7d9df0ed